// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Multiplayer Area
export class AreaMultiplayer {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Return multiplayer access token for specific room. */
    async getMultiplayerToken(room) {
        return this.dataCore.multiplayerToken(room);
    }
}
